import DefaultAnalyticsConfig from "../../../src/common/analytics/defaultAnalyticsConfig";

let erTag = DefaultAnalyticsConfig.erTag;
if (process.env.ENV === "production") {
  erTag = "a6c7210021d04ab9bd2b032664d10a07";
}

export default class analyticsConfig extends DefaultAnalyticsConfig {
  static gaTag = "UA-119793932-5";
  static erTag = erTag;
  static erUserReferenceType = "subscriptionReference";
}



// WEBPACK FOOTER //
// ./clients/alo-sag/js/analyticsConfig.js